import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { Building2, Mail } from "lucide-react";

export default function AdminSettings() {
  const { user } = useAuth();
  useEffect(() => { document.title = "Settings | Sambiva Admin"; }, []);

  const Row = ({ label, value }) => (<div className="flex justify-between py-3 border-b border-black/5 last:border-0 text-sm"><span className="text-sambiva-muted">{label}</span><span className="text-sambiva-charcoal font-medium text-right">{value}</span></div>);

  return (
    <AdminLayout title="Settings">
      <div className="grid md:grid-cols-2 gap-6 max-w-3xl">
        <div className="bg-white rounded-2xl border border-black/5 p-6">
          <div className="flex items-center gap-2 mb-4"><Building2 size={18} className="text-sambiva-green" /><h3 className="font-semibold text-sambiva-charcoal">Business</h3></div>
          <Row label="Brand" value="Sambiva" />
          <Row label="Company" value="GST Foods" />
          <Row label="Address" value="Rua das Olarias, 10" />
          <Row label="City" value="6000-176 Castelo Branco" />
          <Row label="Country" value="Portugal" />
          <Row label="VAT Rate" value="23%" />
          <Row label="Currency" value="EUR (€)" />
        </div>
        <div className="bg-white rounded-2xl border border-black/5 p-6">
          <div className="flex items-center gap-2 mb-4"><Mail size={18} className="text-sambiva-green" /><h3 className="font-semibold text-sambiva-charcoal">Admin Account</h3></div>
          <Row label="Email" value={user?.email} />
          <Row label="Name" value={user?.name} />
          <Row label="Role" value="Administrator" />
          <p className="text-xs text-sambiva-muted mt-4">Transactional email delivery uses your configured SMTP (Outlook) credentials. When unset, emails are recorded in the Email Log.</p>
        </div>
      </div>
    </AdminLayout>
  );
}
